// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  URL_SERVICES_1: 'https://api.dev.featherdev.com',
  URL_SERVICES_2: 'https://api.dev.featherdev.com',
  //URL_SERVICES_1: 'http://localhost:8761',
  //URL_SERVICES_2: 'http://localhost:8761',
  //URL_SERVICES: 'http://localhost:', //Ambiente Local
  LINK_RECUPERAR_PWD: 'https://dev.featherdev.com/cambiar-contrasenia#'
  //LINK_RECUPERAR_PWD: 'http://localhost:4200/cambiar-contrasenia#' //Ambiente local
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
